export enum Platform {
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  MESSENGER = 'Messenger'
}

export enum FacebookMetricSection {
  PLATFORM_OVERVIEW = 'platformOverview',
}
